import { render, staticRenderFns } from "./PresumptiveList.vue?vue&type=template&id=13275da6&scoped=true"
import script from "./PresumptiveList.vue?vue&type=script&lang=js"
export * from "./PresumptiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13275da6",
  null
  
)

export default component.exports